import buttonLoader from '../../utilities/buttonLoader';

const initialProps = {
  container: '.checkout__container',
  loginForm: '.cart__login-form',
  updateForm: '.cart__quantity-form',
  shippingForm: '.js-update-shipping-provider',
  paymentForm: '.js-update-payment-provider',
  submitPay: '.js-checkout',
  cartContainer: '.checkout__cart',
  viewCart: '.checkout__view-cart',
  closeCart: '.checkout__close-cart',
};


class Checkout {
  constructor(props) {
    this.props = props ? props : initialProps;
    this.container = document.querySelector(this.props.container);
    this.bindSubmitShipping();
    this.updateCustomerInformation();
    this.updateShipping();
    this.updatePayment();
    this.openCart();
    this.closeCart();
    this.submit = this.submit.bind(this);
    this.submitNewCustomerInformation = this.submitNewCustomerInformation.bind(this);
    this.renderMessage = this.renderMessage.bind(this);
  }

  bindSubmitShipping() {
    const { submitPay } = this.props;
    const button = document.querySelector(submitPay);
    const shippingName = document.getElementById('shippingName');
    const shippingAddress = document.getElementById('shippingAddress');
    const shippingZipCode = document.getElementById('shippingZipCode');
    const shippingCity = document.getElementById('shippingCity');
    const customerLocation = document.getElementById('customerLocation');
    const shippingName1 = document.getElementById('shippingName1');
    const shippingAddress1 = document.getElementById('shippingAddress1');
    const shippingZipCode1 = document.getElementById('shippingZipCode1');
    const shippingCity1 = document.getElementById('shippingCity1');
    const customerLocation1 = document.getElementById('customerLocation1');
    const updateFormRadioButton = document.querySelector('.js-update-form-radio-button'); // custom address
    const updatePostboxFormRadioButton = document.querySelector('.js-update-postbox-form-radio-button'); // postbox address
    const { paymentForm } = this.props;
    const paymentFormEl = document.querySelector(paymentForm);

    if (button) {

      button.addEventListener('click', e => {
        e.preventDefault();

        if (shippingAddress1.value.length > 0 && shippingZipCode1.value.length > 0 && shippingCity1.value.length > 0 && shippingName1.value.length > 0 && updateFormRadioButton.classList.contains("radio-is-selected")) {
          shippingAddress.value = shippingAddress1.value;
          shippingZipCode.value = shippingZipCode1.value;
          shippingCity.value = shippingCity1.value;
          shippingName.value = shippingName1.value;
          this.submitNewCustomerInformation();
        } 
        else if (customerLocation1.value.length > 0 && updatePostboxFormRadioButton.classList.contains("radio-is-selected")) {
          customerLocation.value = customerLocation1.value;
          this.submitNewCustomerInformation();
        }
        else {
          this.submit();
        }
      });
    }
    
    if (shippingName1) {
      shippingName1.addEventListener('input', () => {
        this.checkCustomAddressInputs(button, paymentFormEl, shippingName1, shippingAddress1, shippingCity1, shippingZipCode1);
      });
    }

    if (shippingAddress1) {
      shippingAddress1.addEventListener('input', () => {
        this.checkCustomAddressInputs(button, paymentFormEl, shippingName1, shippingAddress1, shippingCity1, shippingZipCode1);
      });
    }

    if (shippingZipCode1) {
      shippingZipCode1.addEventListener('input', () => {
        this.checkCustomAddressInputs(button, paymentFormEl, shippingName1, shippingAddress1, shippingCity1, shippingZipCode1);
      });
    }

    if (shippingCity1) {
      shippingCity1.addEventListener('input', () => {
        this.checkCustomAddressInputs(button, paymentFormEl, shippingName1, shippingAddress1, shippingCity1, shippingZipCode1);
      });
    }

    if (customerLocation1) {
      customerLocation1.addEventListener('change', () => {
        this.checkPostboxInput(button, paymentFormEl, customerLocation1);
      });
    }
  }

  openCart() {
    const { cartContainer, viewCart } = this.props;
    const button = document.querySelector(viewCart) ? document.querySelector(viewCart) : null;
    if (button) {
      const cart = document.querySelector(cartContainer) ? document.querySelector(cartContainer) : null;
      button.addEventListener('click', e => {
        e.preventDefault();
        cart.classList.add('cart-open');
      });
    }
  }

  closeCart() {
    const { cartContainer, closeCart } = this.props;
    const button = document.querySelector(closeCart) ? document.querySelector(closeCart) : null;
    if (button) {
      const cart = document.querySelector(cartContainer) ? document.querySelector(cartContainer) : null;
      button.addEventListener('click', e => {
        e.preventDefault();
        cart.classList.remove('cart-open');
      });
    }
  }

  updateCustomerInformation() {
    const { updateForm } = this.props;
    const me = this;
    const updateInformationForm = document.querySelector(updateForm) ? document.querySelector(updateForm) : null;
    if (updateInformationForm) {
      updateInformationForm.addEventListener('submit', (e) => {

        e.preventDefault();
        e.stopImmediatePropagation();

        var data = new FormData(updateInformationForm);

        let youShallNotPass = false;

        const inputs = updateInformationForm.getElementsByTagName("input");
        for (var i = 0, len = inputs.length; i < len; i++) {
          const input = inputs[i];

          if (input.type === "hidden") {
            continue;
          }

          if (input.type === "radio" && !input.checked) {
            youShallNotPass = true;
          }
          if (input.type === "radio" && input.checked) {
            youShallNotPass = false;
            break;
          }

          if (input.type === "text" && !input.value) {
            youShallNotPass = true;
          }
          if (input.type === "text" && input.value) {
            youShallNotPass = false;
            break;
          }

          if (input.type === "number" && !input.value) {
            youShallNotPass = true;
          }
          if (input.type === "number" && input.value) {
            youShallNotPass = false;
            break;
          }
          if (input.type === "tel" && !input.value) {
            youShallNotPass = true;
          }
          if (input.type === "tel" && input.value) {
            youShallNotPass = false;
            break;
          }

          if (input.type === "email" && !input.value) {
            youShallNotPass = true;
          }
          if (input.type === "email" && input.value) {
            youShallNotPass = false;
            break;
          }

          if (input.type === "checkbox" && !input.checked) {
            youShallNotPass = true;
          }
          if (input.type === "checkbox" && input.checked) {
            youShallNotPass = false;
            break;
          }
        }
        if (!youShallNotPass) {
          const updateButton = updateInformationForm.querySelector('.checkout-update');

          var xhr = new XMLHttpRequest();
          xhr.open(updateInformationForm.getAttribute("method"), updateInformationForm.getAttribute("action"));

          xhr.onloadstart = function () {
            buttonLoader.start(updateButton);
          };

          xhr.onloadend = function () {
            var resp = JSON.parse(xhr.response);

            if (xhr.status >= 200 && xhr.status < 300) {

              buttonLoader.success(updateButton);
              const currentFlow = document.querySelector('.checkout__step2');
              const nextFlow = document.querySelector('.checkout__step3');
              currentFlow.classList.add('is-hidden');
              nextFlow.classList.remove('is-hidden');

            } else {

              buttonLoader.reset(updateButton);
              me.renderMessage(button, 'Server error', 'error');
            }

          };

          xhr.send(data);
        }
      });
    }
  }

  updateShipping() {
    const { shippingForm, submitPay } = this.props;
    const me = this;
    const shippingName1 = document.getElementById('shippingName1');
    const shippingAddress1 = document.getElementById('shippingAddress1');
    const shippingZipCode1 = document.getElementById('shippingZipCode1');
    const shippingCity1 = document.getElementById('shippingCity1');

    const updateShippingForm = document.querySelector(shippingForm) ? document.querySelector(shippingForm) : null;
    const radios = document.querySelectorAll('input[name=ShippingProvider]');

    if (updateShippingForm) {
      if (radios) {
        radios.forEach(check => {
          // if already checked 
          if (check.checked) {
            check.parentElement.parentElement.classList.add('hasSelectedRadio');
          }

          check.addEventListener('change', e => {
            const submitButton = document.querySelector(submitPay);

            var data = new FormData(updateShippingForm);
          
            var xhr = new XMLHttpRequest();
            xhr.open(updateShippingForm.getAttribute("method"), updateShippingForm.getAttribute("action"));

            xhr.onloadstart = function () {
              buttonLoader.start(submitButton);
            };

            xhr.onload = function () {
              var resp = JSON.parse(xhr.response);

              if (xhr.status >= 200 && xhr.status < 300) {
                e.preventDefault();

                document.querySelector('.js-pay-update-shipping').value = e.target.value;
                buttonLoader.success(submitButton);

                if (!e.target.classList.contains('js-update-form-radio')) {
                  var parent = e.target.parentElement;
                  var grandparent = parent.parentElement;
                  grandparent.classList.add("hasSelectedRadio");
                }
                if (e.target.classList.contains('shipping-provider-customAddress')) {
                  if (shippingAddress1.value.length === 0 || shippingZipCode1.value.length === 0 || shippingCity1.value.length === 0 || shippingName1.value.length === 0) {
                    submitButton.setAttribute("disabled", "disabled");
                  }
                }
                if (e.target.classList.contains('shipping-provider-postbox')) {
                  if (customerLocation1.value.length === 0 || customerLocation1.selectedOptions[0] === customerLocation1.options[0]) {
                    submitButton.setAttribute("disabled", "disabled");
                  }
                }

                if (document.querySelector('.js-shipping-container')) {

                  document.querySelector('.js-shipping-container').innerHTML = `
                          <div class="t--left"><small>Sendingarmáti</small><br /><small>${resp.shippingProvider.title}</small></div>
                          <div class="flex-align-right">${resp.shippingProvider.price.withVat.currencyString}</div
                          `;
                }
                me.updateTotalPrice(resp.chargedAmount.currencyString);
                buttonLoader.success(submitButton);
            
              } else {
                me.renderMessage(button, 'Server error', 'error');
              }

            };

            xhr.send(data);

            setTimeout(() => {
              this.updateButtonState(); // timeout is set because this was happening before hasSelectedRadio class was added
            }, 300)
          });
        });
      }
    }
  }
  
  updatePayment() {
    const { paymentForm } = this.props;
    const updatePaymentForm = document.querySelector(paymentForm) ? document.querySelector(paymentForm) : null;
    const radios = document.querySelectorAll('input[name=PaymentProvider]');

    radios.forEach(radio => {
      // if already checked 
      if (radio.checked) {
        radio.parentElement.parentElement.classList.add('hasSelectedRadio');
      }
      radio.addEventListener('change', e => {
        if(updatePaymentForm) {
          if (e.target.classList.contains('js-update-payment-provider')) {
            var parent = e.target.parentElement;
            var grandparent = parent.parentElement;
            grandparent.classList.add("hasSelectedRadio");
            document.querySelector('.js-pay-update-payprovider').value = e.target.value;
            this.updateButtonState();
            
          }
        }
      })
    })

  }
  
  updateButtonState() {
    const { paymentForm, shippingForm, submitPay } = this.props;
    const submitButton = document.querySelector(submitPay);
    const updateShippingForm = document.querySelector(shippingForm) ? document.querySelector(shippingForm) : null;
    const updatePaymentForm = document.querySelector(paymentForm) ? document.querySelector(paymentForm) : null;

    if (updatePaymentForm.classList.contains('hasSelectedRadio') && updateShippingForm.classList.contains('hasSelectedRadio')) {

      const updateFormRadioButton = document.querySelector('.js-update-form-radio-button'); // custom address
      const updatePostboxFormRadioButton = document.querySelector('.js-update-postbox-form-radio-button'); // postbox address

      const shippingName1 = document.getElementById('shippingName1');
      const shippingAddress1 = document.getElementById('shippingAddress1');
      const shippingZipCode1 = document.getElementById('shippingZipCode1');
      const shippingCity1 = document.getElementById('shippingCity1');
      const customerLocation1 = document.getElementById('customerLocation1');

      if (updateFormRadioButton && updateFormRadioButton.classList.contains('radio-is-selected')) {
        this.checkCustomAddressInputs(submitButton, updatePaymentForm, shippingName1, shippingAddress1, shippingZipCode1, shippingCity1);
      }
      else if (updatePostboxFormRadioButton && updatePostboxFormRadioButton.classList.contains('radio-is-selected')) {
        this.checkPostboxInput(submitButton, updatePaymentForm, customerLocation1);
      }
      else {
        buttonLoader.success(submitButton);
        submitButton.removeAttribute("disabled");
      }
     
    }
  }

  checkCustomAddressInputs(button, paymentForm, shippingName1, shippingAddress1, shippingZipCode1, shippingCity1) {
    if (shippingName1.value.length > 0 && shippingAddress1.value.length > 0 && shippingZipCode1.value.length > 0 && shippingCity1.value.length > 0 && paymentForm.classList.contains('hasSelectedRadio')) {
      button.removeAttribute("disabled");
      buttonLoader.start(button);
      buttonLoader.reset(button);
    }
    else {
      button.setAttribute("disabled", "disabled");
    }
  }

  checkPostboxInput(button, paymentForm, customerLocation1) {
    if (customerLocation1.value.length === 0 || customerLocation1.selectedOptions[0] === customerLocation1.options[0] && paymentForm.classList.contains('hasSelectedRadio')) {
      button.setAttribute("disabled", "disabled");
    }
    else {
      button.removeAttribute("disabled");
      buttonLoader.start(button);
      buttonLoader.reset(button);
    }
  }

  updateTotalPrice(price) {
    const jstotal = document.querySelector(".js-cart-total");
    jstotal.innerHTML = price;
  }
  submitNewCustomerInformation() {
    const { submitPay } = this.props;
    const submitButton = document.querySelector(submitPay);

    const me = this;

    const updateCustomerForm = document.querySelector('.js-cart-update-customer-form');

    if (updateCustomerForm) {
      const data = new FormData(updateCustomerForm);

      const xhr = new XMLHttpRequest();
      xhr.open(updateCustomerForm.getAttribute("method"), updateCustomerForm.getAttribute("action"));

      xhr.onloadstart = function () {
        buttonLoader.start(submitButton);
      };

      xhr.onload = function () {
        var resp = JSON.parse(xhr.response);

        if (xhr.status >= 200 && xhr.status < 300) {

            me.submit();

        } else {
          buttonLoader.reset(submitButton);
          me.renderMessage(button, 'Server error', 'error');
        }
      };

      xhr.send(data);
    }
  }

  submit() {
    const { submitPay } = this.props;
    const paymentForm = document.querySelector('.cart__payment-form');

    if (paymentForm) {
      paymentForm.submit();
    }
  }
  
  renderMessage(el, message, type) {
    el.insertAdjacentHTML('afterend', '<div class="alert ' + type + '">' + message + '</div>');
  }
}

export default Checkout;
